// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1J2KW","disabled":"FileBtn_disabled__2EMOI","warn":"FileBtn_warn__oYXPh","fade":"FileBtn_fade__1D0ha"};